@switch (type) {
	@case (OrderStatus.COMPLETE) {
		<div class="label paid">
			<p class="title2">{{ 'account.paid' | translateWithKeys }}</p>
		</div>
	}
	@case (OrderStatus.CANCELED) {
		<div class="label rejected">
			<p class="title2">{{ 'account.rejected' | translateWithKeys }}</p>
		</div>
	}
	@case (OrderStatus.PENDING) {
		<div class="label rejected">
			<p class="title2">{{ 'account.rejected' | translateWithKeys }}</p>
		</div>
	}
	@default {}
}
